import classNames from "classnames";
import { useThemeContext } from "@/react/providers";
import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import type { Space } from "@circle-react/types";
import { EmojiRenderer } from "@circle-react-shared/EmojiRenderer";
import { Icon } from "@circle-react-shared/Icon";
import { shouldRenderLockIcon } from "./utils";

export interface SpaceEmojiProps {
  className?: string;
  space: Space;
}

export const SpaceEmoji = ({ space, className }: SpaceEmojiProps) => {
  const { currentAppearance } = useThemeContext();
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const shouldUseLockIcon = shouldRenderLockIcon({
    shouldShowLockIconForNonMembers:
      space.show_lock_icon_for_non_members && !space.is_space_member,
    isPrivate: space.is_private,
    isAdmin,
  });

  return (
    <EmojiRenderer
      className={classNames("title-emoji w-5", className)}
      emoji={space.emoji}
      appearance={currentAppearance}
      customEmojiUrl={space.custom_emoji_url}
      customEmojiDarkUrl={space.custom_emoji_dark_url}
      shouldUseLockIcon={shouldUseLockIcon}
      lockIcon={<Icon type="lock" className="text-dark" />}
      dataTestId="title-emoji"
    />
  );
};
